import { AuthUser } from "@lib/types/Auth";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { resetSidebar, updateSidebar } from "./screen";

interface IUser {
  user: AuthUser | undefined;
  isAuthenticated: boolean;
}

const initialState: IUser = {
  isAuthenticated: false,
  user: undefined,
};

const slice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthUser>) => {
      action.payload.fullName =
        action.payload.firstName + " " + action.payload.lastName;
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    setLogout: (state) => {
      state.user = undefined;
      state.isAuthenticated = false;
    },
  },
});

export default slice.reducer;

export const { setAuth: setAuthAction } = slice.actions;

export const setAuth = (user: AuthUser) => async (dispatch: any) => {
  dispatch(setAuthAction(user));
  if (user?.isManagement) {
    dispatch(
      updateSidebar({
        width: 0,
        collapsed: true,
        hidden: true,
        dontOpen: true,
      }),
    );
  }
};

export const logout = () => async (dispatch: any) => {
  // await dispatch(setPageLoading(true));
  // try {
  //   await API.get(`/logout`);
  // } catch (error) {}
  await dispatch(slice.actions.setLogout());
  dispatch(resetSidebar());
  // window.location.replace(ROUTES.AUTH.LOGIN);

  // await dispatch(setPageLoading(false));
};
